// extracted by mini-css-extract-plugin
export default {"PageProductFooter":"PageProductFooter_PageProductFooter__LFhOo","questions":"PageProductFooter_questions__qTW19","or":"PageProductFooter_or__udfTx"};